import { useQuery } from 'react-query';
import { buildEndpoint } from '../endpoints';
import { apifetch } from '../robotapi';

export interface Forecast {
    forecastExpirationValues?: ForecastValue;
    successChance?: number;
    suggest?: ForecastSuggest;
    monthlyForecastValues?: ForecastRetirementMonthlyValues;
}

interface ForecastValue {
    date?: Date;
    pessimistic?: number;
    median?: number;
    optimistic?: number;
}

interface ForecastSuggest {
    paymentSingleAmount?: number;
    paymentRecurringAmountYearly?: number;
    investmentEndDate?: Date;
}

interface ForecastRetirementMonthlyValues {
    pessimistic?: Array<number>;
    median?: Array<number>;
    optimistic?: Array<number>;
}

export interface ForecastRequest {
    riskProfileId?: number;
    paymentSingleAmount?: number;
    paymentRecurringAmount?: number;
    paymentRecurringInterval?: 'Month' | 'Year';
    investmentEndDate?: string;
    paymentRecurringEndDate?: string;
    targetCapital?: number;
    automaticRiskReduction?: boolean;
    retirementPeriodInYears?: number;
    calculationMode?: string;
}



const getInvestmentForecastUrl = buildEndpoint(['forecast']);

const getInvestmentForecastApiCall = (body: ForecastRequest) =>
    apifetch<Forecast, ForecastRequest>(getInvestmentForecastUrl, 'POST')(body);

export const useGetInvestmentForecast = (body: ForecastRequest, enabled: boolean) => {
    const query = useQuery<Forecast>(['forecast', body], async () => {
        return getInvestmentForecastApiCall(body);
    },
    {enabled: enabled}
    );

    return query;
};